

<!DOCTYPE html>

<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1">
  <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css" rel="stylesheet">
  <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/js/bootstrap.bundle.min.js"></script>
  <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.0.8/css/all.css">
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
  <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css">
</head>








<div class="card" *ngIf="ShowCard===2">
  <div class="card-body">
<br>
    <div class="row">
      <p style="color: #6ab187;"><strong>EMPLOYEE SCREENING</strong></p>
      <div class="col-3"><img style="width: 37px;height: auto;" src="assets/users.png"><a style="text-decoration: none;color:black" routerLink="/whitecollar"> <strong class="white">&nbsp; White-collar verification</strong></a></div>
      <div class="col-3"><img style="width: 37px;height: auto;" src="assets/mechanic.png"><a style="text-decoration: none;color: black;"  routerLink="/bluecollar"><strong class="white"> Blue-collar verification</strong></a></div>
      <br><br>
      <div class="col-3"><img style="width: 37px;height: auto;" src="assets/online-business.png"><a style="text-decoration: none;color: black;" routerLink="/gigworker"> &nbsp;<strong class="white"> Gig Worker verification</strong></a></div>
    </div>
    <br>
    
    <div class="row">
      
      <p style="color: #6ab187;"><strong>RISK & COMPLIANCE</strong></p>
      <div class="col-3"><img style="width: 30px;height: auto;" src="assets/risktopicon.png"><a style="text-decoration: none;color: black;" routerLink="/riskmanage"><strong class="white"> Risk Management</strong></a></div>
      <div class="col-3"><img style="width: 35px;height: auto;" src="assets/onboarding.png"><a style="text-decoration: none;color: black;" routerLink="/vendor"><strong class="white" > Vendor Onboarding</strong></a></div>
      <div class="col-3"><img style="width: 40px;height: auto;" src="assets/distributortopicon.png"><a style="text-decoration: none;color: black;" routerLink="/distribute"><strong class="white"> Distributor onboarding</strong></a></div>
      <div class="col-3"><img style="width: 40px;height: auto;" src="assets/duediligence.jpg"><a style="text-decoration: none;color: black;" routerLink="/duediligence"><strong class="white"> Due Diligence</strong> </a></div>
    </div>
    <br>
  
    <!--  -->
    <div class="row">
      
      <p style="color: #6ab187;"><strong> FINANCIAL INTELLIGENCE</strong></p>
      <div class="col-3"><img style="width: 40px;height: auto;" src="assets/kycsolution.png"><a style="text-decoration: none;color: black;" routerLink="/kycsolution"><strong class="white"> KYC solutions</strong> </a></div>
    </div>
    <br>
  
  </div>
</div>


<div class="card" *ngIf="ShowCard===1">
  <div class="card-body">
<br>
<p style="color: #6ab187;font-weight: 600;"><strong>PRODUCT</strong></p>

    <div class="row">
      <div class="col"><a style="text-decoration: none;color: black;cursor: pointer;" (click)="ShowCard=3"><strong class="white"><img style="width: 4%;height: 100%;" src="assets/docverify.png"> Document Verification</strong> </a></div>
      <div class="col"><a style="text-decoration: none;color: black;cursor: pointer;" routerLink="/service"><strong class="white"><img style="width: 5%;height: 110%;" src="assets/docsignin.png"> Document SignIn</strong> </a></div>
  
    </div>
    <br>

    <div class="row">
       </div>
    <br>
    
  </div>
</div>


<!--  -->

<div class="card" *ngIf="ShowCard===3">
  <div class="card-body">
    <br>
<div class="row">
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/aadhartopicon.png"><a style="text-decoration: none;color: black;" routerLink="/aadhaar"> <strong class="white"> Aadhaar verification</strong></a></div>
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/pantopicon.png"><a style="text-decoration: none;color: black;"  routerLink="/pan"><strong class="white"> Pan verification</strong></a></div>
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/gsttopicon.jpg"><a style="text-decoration: none;color: black;" routerLink="/gst"><strong class="white"> Gst verification</strong></a></div>
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/drivinglicensetop.jpg"><a style="text-decoration: none;color: black;" routerLink="/driving"><strong class="white"> Driving verification</strong></a></div>
</div><br><br>

<div class="row">
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/passporttopicon.png"><a style="text-decoration: none;color: black;" routerLink="/passport"><strong class="white"> Passport verification</strong> </a></div>
  <div class="col"><img style="width: 58px;height: 44px;" src="assets/rcverify.png"><a style="text-decoration: none;color: black;" routerLink="/rcverify"><strong class="white"> RC verification</strong></a></div>
  <div class="col"><img style="width: 45px;height: 44px;" src="assets/msmeverify.png"><a style="text-decoration: none;color: black;" routerLink="/msmeverify"><strong class="white"> MSME verification</strong> </a></div>
  <div class="col"><img style="width: 45px;height: 44px;" src="assets/verification.png"><a style="text-decoration: none;color: black;" routerLink="/dinverify"><strong class="white"> DIN verification</strong></a></div>
</div>

<br><br>
<div class="row">
  <div class="col-3"><img style="width: 35px;height: 44px;border-radius: 20px;" src="assets/cinicon.png"><a style="text-decoration: none;color: black;" routerLink="/cinverify"><strong  class="white"> CIN verification</strong></a></div>
</div>
</div>
</div>


<br><br>



<!-- topic -->
<div class="row"  data-aos="zoom-in" data-aos-delay="300"  >
  <div class="col-md-6 text-center">
    <img style="width:70%;height: 100%;margin-top: 40px;" src="assets/drivingverify.png">
</div>
    <div style="padding-top: 10%;" class="col-md-6">
        <h1>
            <span class="topic">Driving License Verification </span>
          </h1>
        <h5 style="padding-left: 10%;">&nbsp;&nbsp;&nbsp;Identify Counterfeit and forged DLs, used for illegitimate purposes, in real time and seamlessly onboard customers and third parties with plug and play Driver License Verification API  </h5>
    </div>

    
</div>
<br><br>
<br><br>


<!-- drive -->
<div class="row"  data-aos="zoom-in" data-aos-delay="300"  >
    <div class="col">
        <h1 style="text-align: center;font-weight:700;">Fast. Accurate. Efficient.</h1>
        <h6 style="color: gray;text-align: center;">Your line of defense against impersonation frauds and stolen identities</h6>
        <br><br>
       
    </div>
</div>

<div class="row" >
    <div class="col-md-4"  data-aos="fade-up" data-aos-delay="300"  >
        
        <img style="width: 40px;height: 40px;margin-left: 27%;" src="assets/targeted.png"><br><br>
        <h3 style="margin-left: 27%;">99.9%</h3>
        <h4 style="margin-left: 23%;color: #6ab187;">Check Success Rate</h4>

    </div>

    <div class="col-md-4" data-aos="fade-up" data-aos-delay="300" >
        
        <img style="width: 40px;height: 40px;margin-left: 27%;" src="assets/accuracy.png"><br><br>
        <h3 style="margin-left: 27%;">99%</h3>
        <h4 style="margin-left: 23%;color: #6ab187;">Verification Accuracy</h4>
        
    </div>

    
    <div class="col-md-4" data-aos="fade-up" data-aos-delay="300" >
        
        <img style="width: 50px;height: 40px;margin-left: 27%;" src="assets/responsetime.png"><br><br>
        <h3 style="margin-left: 27%;">1-5 Secs</h3>
        <h4 style="margin-left: 23%;color: #6ab187;">Response Time</h4>
        
    </div>
</div>
<br><br><br>

<div class="row" data-aos="fade-up" data-aos-delay="300"   >
  <div style="text-align: center;" class="col">
    <h2 style="color:#6ab187;">Instant Verification Check</h2><br>
    <h3>Building an Additional Layer of Security for <br> Fraud Prevention</h3>
    <h5 style="color: gray;">DL Verification services for fast and efficient authentication of drivers</h5>
  </div>
</div>
<br><br><br>



<div class="row p-4"  data-aos="fade-up" data-aos-delay="300" >
  <div class="col-md-6 text-center">
    <img style="border-radius: 50%;width: 90%;" src="assets/drivinglicense.png">
  </div>
  <div  class="col-md-6">
    <h5 style="color: #6ab187;">DL Verification</h5>
    <h4>What is Driving License Verification?</h4>
    <h6>A driver’s license is one of the most easily forged documents as it<br> does not include enhanced security features like identity cards or<br> passports.</h6><br>
    <h6>With driver license verification API you can:</h6>
    <br>
    <h6><img style="width:20px;height: 20px;" src="assets/check-mark.png">Screen out false licenses/underage drivers</h6><br>
    <h6><img style="width:20px;height: 20px;" src="assets/check-mark.png">Onboard individuals with a valid driving license</h6><br>
    <h6><img style="width:20px;height: 20px;" src="assets/check-mark.png">Get identity proof of customers, employees, and third parties</h6>
    <br>
    <h4>Get Started<img style="width: 30px;height: 30px;" src="assets/arroww.jpg"> </h4>
  </div>
  <br><br>
  
</div>

<br>

<div class="row" data-aos="zoom-in" data-aos-delay="300" >
  <div style="text-align: center;" class="col">
    <h5>How to do Driving License Verification?</h5>
    <h1 style="color: #6ab187;">How FACheck's Driving License<br> Verification API Works?</h1>
    <h5 style="color: gray;">Online DL Verification Done In Seconds!</h5>
    <br><br>
  </div>


<br><br>
</div>
<div  class="row p-4" data-aos="fade-up" data-aos-delay="300"  >

  <div   class="col-md-4 ">
      <br>
      <img style="width: 60px;height: 65px;" src="assets/dldobcard.png">
     <br><br><br>
      <h5>STEP 1</h5>
      <p style="align-items: center;">Enter DL number and DOB</p>
  </div>

  <div class="col-md-4 ">
        <br>
        <img style="width: 70px;height: 80px;" src="assets/seva.png">
       <br><br>
        <h5>STEP 2</h5>
        <p style="align-items: center;">Driving license API verifies the details from Parivahan Sewa and other government database</p>
    </div>
   
    <div class="col-md-4 ">
   
      <br>
      <img style="width: 60px;height: 60px;" src="assets/drivehierarchy.png">
     <br><br><br>
      <h5 >STEP 3</h5>
      <p style="align-items: center;">Fetch instantaneous verification responses for the following data points: DL number, owner’s name father’s name, DOB, address, etc.<p>
  </div>

</div>
<br><br>

  <h1 data-aos="zoom-in" data-aos-delay="300"  style="text-align: center;color: #6ab187;">Facheck Digital Verification Checks​</h1><br>

  <br>
  <!-- verification api's -->
    <div  class="row p-2">
      <div class="col-md-3 mt-3" data-aos="fade-up" data-aos-delay="300"  >
          <div  class="card"  >
              <div style="background-color: #c9d9e6;height: 160px;" class="card-body">
                  <img style="width: 34%;height:30%" src="assets/passportverification.png">
                  <br><br>
                <h5 class="card-title">Passport Verification</h5>
  
              </div>            
            </div>
      </div>
  
      <div class="col-md-3 mt-3" data-aos="fade-up" data-aos-delay="300"  >
        <div class="card"  >
            <div style="background-color: #c9d9e6;height: 160px;"  class="card-body" >
                <img style="width: 34%;height:30%" src="assets/panchecks.png">
                <br><br>
              <h5 class="card-title">PAN Card Verification</h5>

            </div>            
          </div>
    </div>

    <div class="col-md-3 mt-3" data-aos="fade-up" data-aos-delay="300"  >
      <div class="card"  >
          <div style="background-color: #c9d9e6;height: 160px;"  class="card-body">
              <img style="width: 34%;height:30%" src="assets/aadharchecks.jpg">
              <br><br>
            <h5 class="card-title">Aadhaar Verification</h5>

          </div>            
        </div>
  </div>
  
  <div class="col-md-3 mt-3" data-aos="fade-up" data-aos-delay="300"  >
    <div class="card"  >
        <div style="background-color: #c9d9e6;height: 160px;"  class="card-body">
            <img style="width: 34%;height:30%"  src="assets/voteridchecks.png">
            <br><br>
          <h5 class="card-title">VoterId Verification</h5>

        </div>            
      </div>
</div>

<div class="col-md-3 mt-3" data-aos="fade-up" data-aos-delay="300"  >
  <div class="card"  >
      <div style="background-color: #c9d9e6;height: 160px;"  class="card-body">
          <img style="width: 34%;height:30%" src="assets/electricitybill.png">
          <br><br>
        <h5 class="card-title">Electricity Bill check</h5>

      </div>            
    </div>
</div>

<div class="col-md-3 mt-3" data-aos="fade-up" data-aos-delay="300"  >
  <div  class="card"  >
      <div style="background-color: #c9d9e6;height: 160px;" class="card-body">
          <img style="width: 25%;height:25%" src="assets/uanchecks.png">
          <br><br>
        <h5 class="card-title">UAN Verification</h5>

      </div>            
    </div>
</div>

<div class="col-md-3 mt-3" data-aos="fade-up" data-aos-delay="300"  >
<div class="card"  >
    <div style="background-color: #c9d9e6;height: 160px;"  class="card-body">
        <img style="width: 25%;height:25%" src="assets/vehiclerc.png">
        <br><br>
      <h5 class="card-title">Vehicle RC Verification</h5>
     
    </div>            
  </div>
</div>

<div class="col-md-3 mt-3" data-aos="fade-up" data-aos-delay="300"  >
<div class="card"  >
  <div style="background-color: #c9d9e6;height: 160px;"  class="card-body">
      <img style="width: 34%;height:30%" src="assets/udyamaadhar.jpg">
      <br><br>
    <h5 class="card-title">Udyam Aadhaar</h5>

  </div>            
</div>
</div>
<div class="col-md-3 mt-3"></div>
<div class="col-md-3 mt-3" data-aos="fade-up" data-aos-delay="300"  >
<div class="card"  >
<div style="background-color: #c9d9e6;height: 160px;"  class="card-body">
    <img style="width: 34%;height:30%" src="assets/gstinchecks.png">
    <br><br>
  <h5 class="card-title">GSTIN Verification</h5>

</div>            
</div>
</div>

<div class="col-md-3 mt-3" data-aos="fade-up" data-aos-delay="300"  >
<div class="card"  >
<div style="background-color: #c9d9e6;height: 160px;"  class="card-body">
  <img style="width: 25%;height:25%" src="assets/qrcode.png">
  <br><br>
<h5 class="card-title">UPI Verification</h5>

</div>            
</div>
</div>
<div class="col-md-3 mt-3"></div>


    </div>

    

    
    
   



    <div class="row" data-aos="zoom-in" data-aos-delay="300"   >
      <div class="col">
        <br><br>
        <!-- Footer -->
        <footer class="text-center text-lg-start text-white" style="background-color: #1c2331">
          <!-- Section: Social media -->
          <section class="d-flex justify-content-between p-4" style="background-color: #6ab187">
            <!-- Left -->
            <div class="me-5">
              <span>Get connected with us on social networks:</span>
            </div>
            <!-- Left -->
    
            <!-- Right -->
            <div>
    
              <a href="" class="text-white me-5">
                <i class="fab fa-instagram"></i>
              </a>
    
    
            </div>
            <!-- Right -->
          </section>
          <!-- Section: Social media -->
    
    
          <section data-aos="zoom-in" data-aos-delay="300" class="p-4">
            <div class="text-center text-md-start mt-5">
    
              <div class="row">
    
                <div class="col-md-4 ">
                  <!-- Content -->
    
                  <h6 style="margin-right: 74%;font-size:16px" class="text-uppercase fw-bold"><img
                      style="width: 27px;height: auto;border-radius: 40%;" src="assets/handlogo.png"> FACheck</h6>
    
                  <p style="text-align: justify;
      text-justify: inter-word">
                    Facheck is a very useful product in the Finance,Banking, and growing Industries in India. It checks &
                    authenticates the Person / Company document and reveals the result with the validity and truth of the
                    document. So, with the help of the Facheck - verification you can process the proper document and
                    avoid fraudulent disclosures. It help your organization to proceed further with Fact-Check of your
                    clients.
                  </p>
                </div>
    
    
                <div class="col-md-2">
                  <!-- Links -->
                  <h6 class="text-uppercase fw-bold" >Solutions</h6>
    
                  <p>
                    <a href="bluecollar"  class="text-white">Blue-collar
                      verify</a>
                  </p>
                  <p>
                    <a href="distribute"  class="text-white">Distributor
                      Onboard</a>
                  </p>
                  <p>
    
                    <a href="duediligence"  class="text-white">Due
                      Diligence</a>
                  </p>
                  <p>
    
                    <a href="gigworker"  class="text-white">Gig Worker
                      Verify</a>
    
                  </p>
                  <p>
    
                    <a href="kycsolution"  class="text-white">KYC
                      Solutions</a>
                  </p>
                  <p>
                    <a href="riskmanage"  class="text-white">Risk Manage</a>
                  </p>
                  <p>
    
                    <a href="vendor"  class="text-white">Vendor Onboard</a>
                  </p>
                  <p>
    
                    <a href="whitecollar"  class="text-white">White-collar
                      verify</a>
                  </p>
                </div>
    
    
                <div  class="col-md-2 text-align">
    
                  <h6 class="text-uppercase fw-bold" >Products</h6>
    
                  <p>
                    <a href="aadhaar"  class="text-white">Aadhaar verify</a>
                  </p>
                  <p>
                    <a href="cinverify"  class="text-white">CIN verify</a>
                  </p>
                  <p>
                    <a href="dinverify"  class="text-white">DIN verify</a>
                  </p>
                  <p>
                    <a href="driving"  class="text-white">Driving License</a>
                  </p>
                  <p>
                    <a href="gst"  class="text-white">GST verify</a>
                  </p>
                  <p>
                    <a  href="msmeverify" class="text-white">MSME verify</a>
                  </p>
                  <p>
                    <a href="pan"  class="text-white">PAN verify</a>
                  </p>
                  <p>
                    <a href="passport"  class="text-white">Passport verify</a>
                  </p>
                  <p>
                    <a href="rcverify"  class="text-white">RC verify</a>
                  </p>
    
                  <br><br><br>
                </div>
    
    
    
    
                <div  class="col-md-4 text-center">
    
                  <h6  class="text-uppercase fw-bold">Quick links</h6>
    
    
                  <a  href="privacypolicy">Privacy Policy</a>
                  <br><br>
                  <a  href="termscondition">Terms & Condition</a>
                  <br><br>
    
                  <a  href="refundpolicy">Refund Policy</a>
                  <br><br>
                  <!-- Links -->
                  <h6 class="text-uppercase fw-bold">Contact</h6>
    
    
                  <p >support@facheck.in &nbsp;<i
                      class="fas fa-envelope mr"></i> </p>
    
                  <p  class=" text-center ">Registered Head Office <i class="fas fa-home"></i>
                    <br>New 9, Old # 11, Ground Floor,
                    Palayakaran Street, Kalaimagal Nagar, Ekkaduthangal, Chennai
                  </p>
    
                </div>
    
    
              
    
    
              </div>
              <!-- Grid row -->
    
    
            </div>
          </section>
          <br>
          <div class="text-center p-3" style="background-color: rgba(0, 0, 0, 0.2)">
            Copyright© 2023. Powered by
            <a class="text-white" href="#">facheck.com
              | All Rights Reserved </a>
          </div>
    
        </footer>
        <!-- Footer -->
    
      </div>
    </div>
    
    